export const UNEDITABLE_FIELDS_OF_TERMINAL = ['id', 'state']
